module.exports = __webpack_public_path__ + "static/img/ela-masthead.6f0aa03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/ela-masthead.jpg
// module id = tKrx
// module chunks = 1